import { apiClient } from './axios';

import type { AuthResponse } from '@repo/shared-types';

export const authApi = {
  requestCode: async (email: string) => {
    const response = await apiClient.post<{ message: string }>('/auth/login', { email });
    return response.data;
  },

  verifyCode: async (email: string, code: string) => {
    const response = await apiClient.post<AuthResponse>('/auth/verify-code', { email, code });
    return response.data;
  },

  loginWithPassword: async (email: string, password: string) => {
    const response = await apiClient.post<AuthResponse>('/auth/login-password', {
      email,
      password,
    });
    return response.data;
  },

  resendCode: async (email: string) => {
    const response = await apiClient.post<{ message: string }>('/auth/resend-code', { email });
    return response.data;
  },

  refreshToken: async (refreshToken: string) => {
    const response = await apiClient.post<AuthResponse>('/auth/refresh', { refreshToken });
    return response.data;
  },

  setPassword: async (password: string) => {
    const response = await apiClient.post<{ message: string }>('/auth/set-password', { password });
    return response.data;
  },
};
